import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { User } from "@iventis/domain-model/model/user";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { DigitalTwinLicence } from "@iventis/domain-model/model/digitalTwinLicence";

interface InstanceTableProps {
    licences: DigitalTwinLicence[];
    licenceToUserMap: Record<string, User>;
}

const LicenceTable: React.FC<InstanceTableProps> = ({ licences, licenceToUserMap }) => {
    const translate = useIventisTranslate();

    return (
        <TableContainer component={Paper} style={{ maxHeight: 200, overflowY: "auto" }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{translate(Content.map9.digitalTwin.occupiedTable.user)}</TableCell>
                        <TableCell>{translate(Content.map9.digitalTwin.occupiedTable.status)}</TableCell>
                        <TableCell>{translate(Content.map9.digitalTwin.occupiedTable.id)}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {licences?.map((licence) => (
                        <TableRow key={licence.id}>
                            <TableCell>{licenceToUserMap[licence.id]?.email}</TableCell>
                            <TableCell>{translate(Content.map9.digitalTwin.status[licence.instance?.status])}</TableCell>
                            <TableCell>{licence.id}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LicenceTable;
